import React, { useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { acceptTerms } from "../../../_service/users/user.service";
import { setToast } from "../../../app/modules/toast";
import { actions } from "../../../app/modules/Auth/_redux/authRedux";
import "./terms.scss";


//import { getOrganizationsList } from "../../../app/modules/Organizations/_redux/organizationsSelectors";
//import { actions as Organizations } from "../../../app/modules/Organizations/_redux/organizationsRedux";

export function TermsPage() {
//  const organization = useSelector(getOrganizationsList);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  }, []);
  const history = useHistory();

  const handleChange = () => {
    history.push("/dashboard");
  };
  const acceptAction = async () => {
    setLoading(true);
    try {
      await acceptTerms();
      dispatch(actions.updateTermsAccepted(true));
      setLoading(false);
      history.push("/dashboard");     
    }
    catch {
      setToast("An error occurred attempting to accept terms.", "error");
      setLoading(false);
      
    }
  }
  const logoutAction = () => {
    history.push("/logout");
  }

  return (
<div className="agreement">
  <h1 className="agreement-title">License Rights</h1>
  <p className="headerp">The Executive Toolkit is provided for the authorized use by the User as stated. Any unauthorized use by any other User will be dealt with to the fullest extent under the law.</p>

  <div className="section" >
    <h2 data-section="1" >License</h2>
    <p data-section="1.1">The Vendor (“eMATE Consulting, LLC”) grants to the Licensee a non-exclusive and non-transferable license (“License”) to The Executive Toolkit (“the Software”).</p>
    <p data-section="1.2">“Software” includes the executable program and any related printed, electronic, and online documentation and any other files that may accompany the product.</p>
    <p data-section="1.3">Title, copyright, and intellectual property rights of the Software remain the exclusivity of the Vendor.</p>
    <p className="subthree" data-section="1.3.1">Intellectual property rights include the look and feel of the Software.</p>
    <p className="subthree" data-section="1.3.2">This Agreement constitutes a license for use only and is not in any way a transfer of ownership rights to the Software.</p>
    <p className="subthree" data-section="1.3.3">Solutions rely on industry-reliable data and are intended to provide strategic direction.</p>
    <p data-section="1.4">The Software will be maintained in the Cloud. No Licensee data will be stored within this environment unless explicitly enumerated.</p>
    <p data-section="1.5">The rights and obligations of this Agreement are personal rights granted for the Licensee only.</p>
    <p className="subthree" data-section="1.5.1">The Licensee may not transfer or assign any of the rights or obligations granted under this Agreement to any other person or legal entity.</p>
    <p className="subthree" data-section="1.5.2">The Licensee may not make available the Software for use by one or more Third Parties.</p>
    <p data-section="1.6">The Software may not be modified, reverse-engineered, or decompiled in any manner through current or available technologies.</p>
    <p data-section="1.7">Failure to comply with any of the terms under the License section will be considered a material breach of this Agreement.</p>
  </div>

  <div className="section">
    <h2 data-section="2" >Limitation of Liability</h2>
    <p data-section="2.1">The Software is provided by the Vendor and accepted by the Licensee “As Is”.</p>
    <p className="subthree" data-section="2.1.1">Liability of the Vendor will be limited to a maximum of the original purchase price of the Software.</p>
    <p className="subthree" data-section="2.1.2">The Vendor will not be liable for any general, special, incidental, or consequential damages including but not limited to, loss of production, loss of profits, loss of revenue, loss of data, or any other business or economic disadvantage suffered by the Licensee arising out of the use or failure to use the Software.</p>
    <p data-section="2.2">The Vendor makes no warranty expressed or implied regarding the fitness of the Software for a particular purpose or that the Software will be suitable or appropriate for the specific requirements of the Licensee.</p>
    <p data-section="2.3">The Vendor does not warrant that use of the Software will be uninterrupted or error-free. The Licensee accepts that Software in general is prone to bugs and flaws within an acceptable level as determined in the industry.</p>
  </div>

  <div className="section"  >
    <h2 data-section="3">Warrants and Representations</h2>
    <p data-section="3.1">The Vendor warrants and represents that it is the copyright holder of the Software.</p>
    <p data-section="3.2">The Vendor warrants and represents that granting the license to use the Software is not in violation of any agreement, copyright, or applicable statutes.</p>
  </div>

  <div className="section">
    <h2 data-section="4" >Acceptance</h2>
    <p data-section="4.1">All terms, conditions, and obligations of this Agreement will be deemed accepted by the Licensee (“Acceptance”) upon execution of this Agreement.</p>
  </div>

  <div className="section">
    <h2 data-section="5" >User Support</h2>
    <p className="base">Limited User support is provided under this Agreement.</p>
  </div>

  <div className="section">
    <h2 data-section="6" >Term</h2>
    <p className="base">The term of the Agreement will begin on Acceptance and continue in perpetuity.</p>
  </div>

  <div className="section">
    <h2 data-section="7" >Termination</h2>
    <p data-section="7.1">This Agreement will be terminated and the License forfeited where the Licensee has failed to comply with any of the terms of this Agreement or is in breach of this Agreement.</p>
    <p data-section="7.2">On Termination of the Agreement for any reason, the Licensee will promptly have their access removed.</p>
  </div>

  <div className="section">
    <h2 data-section="8" >Force Majeure</h2>
    <p className="base">The Vendor will be free of liability to the Licensee where the Vendor is prevented from executing the obligation under this Agreement in whole or in part due to Force Majeure (e.g., earthquake, typhoon, flood, fire, pandemic, and war) or any other unforeseen and uncontrollable event where the Vendor has taken any and all appropriate action to mitigate.</p>
  </div>

  <div className="section">
    <h2 data-section="9" >Governing Law</h2>
    <p data-section="9.1">The parties to the Agreement submit to the jurisdiction of the courts of the State of Georgia for the enforcement of this Agreement or any arbitration award or decision arising from this Agreement.</p>
    <p data-section="9.2">This Agreement will be enforced or construed according to the laws of the State of Georgia.</p>
  </div>

  <div className="section">
    <h2 data-section="10" >Miscellaneous</h2>
    <p data-section="10.1">This Agreement can only be modified in writing signed by both Vendor and Licensee.</p>
    <p data-section="10.2">This Agreement does not create or imply any relationship in agency or partnership between the Vendor and Licensee.</p>
    <p data-section="10.3">Headings are inserted for the convenience of the parties only and are not considered when interpreting the Agreement. Words in the singular mean and include the plural and vice versa. Words in the masculine gender include the feminine gender and vice versa. Words in the neuter gender include the masculine and feminine gender and vice versa.</p>
    <p data-section="10.4">If any term, covenant, condition, or provision of the Agreement is held by a court of competent jurisdiction to be invalid, void, or unenforceable, it is the parties’ intent that such provision be reduced in scope by the court only to the extent deemed necessary.</p>
    <p data-section="10.5">This Agreement contains the entire agreement between the parties. All understandings have been included in this Agreement.</p>
    <p data-section="10.6">This Agreement and the terms and conditions contained in the Agreement are binding upon the Vendor’s successors and assigns.</p>
  </div>

  <div className="section">
    <h2 data-section="11" >Approval</h2>
    <p className="base">By accepting these terms, both parties agree to the terms herein.</p>
  </div>


  <div className="d-flex flex-wrap justify-content-center align-items-center">
          <button
            id="accept-btn"
            type="submit"
            disabled={loading}
            className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
            onClick={acceptAction}
          >
            <span>Accept</span>
          </button>
          <button
            id="accept-btn"          
            disabled={loading}
            className={`btn btn-secondary font-weight-bold px-9 py-4 my-3 ml-5`}
            onClick={logoutAction}
          >
            <span>Logout</span>
          </button>
        </div>  
</div>

  );
}
